export default __webpack_public_path__ + "static/triads_1-59ee6102694235d3dcb507369c16a200.jpg";